<div class="flex-row">
    <div class="flex-left">
        <ion-select
                (ionChange)="changeYear($event)"
                [(ngModel)]="bonusService.selectedYear"
        >
            <ion-select-option *ngFor="let year of bonusService.years"
                               [value]="year">{{year}}</ion-select-option
            >
        </ion-select>
    </div>
    <div class="flex-right" *ngIf="period == 'mese'">
        <ion-select
                (change)="changeMonth($event)"
                [(ngModel)]="bonusService.selectedMonth">
            <ion-select-option value="0">Tutto</ion-select-option>
            <ion-select-option value="1">Gennaio</ion-select-option>
            <ion-select-option value="2">Febbraio</ion-select-option>
            <ion-select-option value="3">Marzo</ion-select-option>
            <ion-select-option value="4">Aprile</ion-select-option>
            <ion-select-option value="5">Maggio</ion-select-option>
            <ion-select-option value="6">Giugno</ion-select-option>
            <ion-select-option value="7">Luglio</ion-select-option>
            <ion-select-option value="8">Agosto</ion-select-option>
            <ion-select-option value="9">Settembre</ion-select-option>
            <ion-select-option value="10">ottobre</ion-select-option>
            <ion-select-option value="11">Novembre</ion-select-option>
            <ion-select-option value="12">Dicemebre</ion-select-option>
        </ion-select>
    </div>
    <div class="flex-right" *ngIf="period == 'trimestrale'">
        <ion-select
                (change)="changeMonth($event)"
                [(ngModel)]="bonusService.selectedQuarter">
            <ion-select-option value="0">Tutto</ion-select-option>
            <ion-select-option value="1">Gen - Mar</ion-select-option>
            <ion-select-option value="2">Apr - Giu</ion-select-option>
            <ion-select-option value="3">Lug - Set</ion-select-option>
            <ion-select-option value="4">Ott - Dec</ion-select-option>
        </ion-select>
    </div>
</div>


<div class="glass-blurred-background padding full-width text-bold">
    <div class="flex-collapsible">
        <div class="flex-row header" (click)="showCareerPanel = !showCareerPanel">
            <div class="flex-left wide">
                <div>
                    <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                         *ngIf="showCompanyBonusPanel">
                    <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                         *ngIf="!showCompanyBonusPanel">
                    Carriera
                </div>
            </div>
            <div class="flex-right">
                {{ owner?.role}}
            </div>
        </div>
        <div class="panel" *ngIf="showCareerPanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="panel" *ngIf="showCareerPanel">
                    <div class="">
                        <div *ngFor="let step of bonusService.careerProgress">
                            <div class="flex-left">
                                <div class="indent"><b>{{step.career.title}} </b></div>
                            </div>
                            <div class="flex-right">
                                <div class="ion-float-right" *ngIf="step?.percent != 1">
                                    <b>{{(step.percent ? step.percent * 100 : 0 * 100)  }} % </b></div>
                                <div class="ion-float-right" *ngIf="step?.percent == 1"><b>
                                    <ion-icon name="star-outline"></ion-icon>
                                </b></div>
                                <ion-progress-bar [value]="step.percent"></ion-progress-bar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br>
    </div>
</div>
<br>
<div class="glass-blurred-background padding full-width text-bold">
    <div class="flex-row">
        <div class="flex-left">
            Fatturato Tot
        </div>
        <div class="flex-right">
            € {{bonusService.getTotalBonus()}}
        </div>
    </div>
</div>
<br>


<div class="flex-tabs" *ngIf="style!=='category'">
    <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'mese'"
         (click)="period = 'mese'">
        Mensile
    </div>
    <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'trimestrale'"
         (click)="period = 'trimestrale'">
        Trimestrale
    </div>
    <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'annuale'"
         (click)="period = 'annuale'">
        Annuale
    </div>
</div>

<div class="flex-tabs" *ngIf="style==='category'">
    <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'personale'"
         (click)="period = 'personale'">
        Personale
    </div>
    <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'squadra'"
         (click)="period = 'squadra'">
        Squadra
    </div>
    <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'rete'"
         (click)="period = 'rete'">
        Rete
    </div>
</div>

<br>

<div class="flex-panel" *ngIf="period == 'mese'">
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showMarketingFeePanel = !showMarketingFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showMarketingFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showMarketingFeePanel">
                        Marketing Fee
                    </div>
                </div>
                <div class="flex-right">
                    € {{bonusService.getBonus(bonusType.MARKETING_FEE_1)|contractAmountSum}}
                </div>
            </div>
            <div class="panel" *ngIf="showMarketingFeePanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row" *ngFor="let b of bonusService.getBonus(bonusType.MARKETING_FEE_1)">
                        <div class="flex-left">{{b?.info}}</div>
                        <div class="flex-left">{{b?.date |getMonthOfawsDate}}</div>
                        <div class="flex-right">€ {{b?.total}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showManagerFeePanel = !showManagerFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showManagerFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showManagerFeePanel">
                        Manager Fee
                    </div>
                </div>
                <div class="flex-right">
                    € {{bonusService.getBonus(bonusType.MANAGER_FEE_2)|contractAmountSum}}
                </div>
            </div>
            <div class="panel" *ngIf="showManagerFeePanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row" *ngFor="let b of bonusService.getBonus(bonusType.MANAGER_FEE_2)">
                        <div class="flex-left">{{b?.info}}</div>
                        <div class="flex-left"> {{b?.date|getMonthOfawsDate}}</div>
                        <div class="flex-right">€ {{b?.total}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showTeamBonusPanel = !showTeamBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showTeamBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showTeamBonusPanel">
                        Team Bonus
                    </div>
                </div>
                <div class="flex-right">
                  <span class="color-white"
                        *ngIf="bonusService?.getBonus(bonusType.BONUS_TEAM_3)>1 ">{{bonusService?.getBonus(bonusType.BONUS_TEAM_3)}}</span>
                    <div *ngIf="bonusService?.getBonus(bonusType.BONUS_TEAM_3)<1">
                        <b>{{bonusService?.getBonus(bonusType.BONUS_TEAM_3) * 100}} %</b>
                        <ion-progress-bar
                                [value]="bonusService?.getBonus(bonusType.BONUS_TEAM_3)"></ion-progress-bar>
                    </div>
                    <!--  <ion-spinner *ngIf="teamBonus==undefined"></ion-spinner> -->
                </div>
            </div>
            <div class="panel" *ngIf="showTeamBonusPanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row">
                        <div class="flex-left">
                            <div>Volume</div>
                        </div>
                        <div class="flex-right">
                            <div>Bonus</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>N. membri*€ 10.000</div>
                        </div>
                        <div class="flex-right">
                            <div>0,50%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>N. membri*€ 20.000</div>
                        </div>
                        <div class="flex-right">
                            <div>1,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>N. membri*€ 30.000</div>
                        </div>
                        <div class="flex-right">
                            <div>1,50%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="flex-panel" *ngIf="period == 'trimestrale'">
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showRevenueFeePanel = !showRevenueFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showRevenueFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showRevenueFeePanel">
                        Revenue Fee
                    </div>
                </div>
                <div class="flex-right">
              <span class="color-white"
                    *ngIf="(bonusService?.getBonus(bonusType.REVENUE_BONUS_4))>1">{{bonusService?.getBonus(bonusType.REVENUE_BONUS_4)}}</span>
                    <div *ngIf="(bonusService?.getBonus(bonusType.REVENUE_BONUS_4))<1">
                        <b>{{(bonusService?.getBonus(bonusType.REVENUE_BONUS_4)) * 100}} %</b>
                        <ion-progress-bar *ngIf="bonusService?.getBonus(bonusType.REVENUE_BONUS_4)"
                                          [value]="bonusService?.getBonus(bonusType.REVENUE_BONUS_4)"></ion-progress-bar>
                    </div>
                </div>
            </div>
            <div class="panel" *ngIf="showRevenueFeePanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row">
                        <div class="flex-left">
                            <div>Volume</div>
                        </div>
                        <div class="flex-right">
                            <div>Bonus</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>100.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>200.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,25%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>300.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,50%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>400.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,75%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>500.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>2,00%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showSponsorFeePanel = !showSponsorFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showSponsorFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showSponsorFeePanel">
                        Sponsor Fee
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ {{bonusService.getBonus(bonusType.SPONSOR_BONUS_5)}}</span>
                </div>
            </div>
            <div class="panel" *ngIf="showSponsorFeePanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row">
                        <div class="flex-left">
                            <div>Volume</div>
                        </div>
                        <div class="flex-right">
                            <div>Bonus</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>100.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,50%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>200.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,75%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>300.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>400.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,25%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>500.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,50%</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showLeaderBonusPanel = !showLeaderBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showLeaderBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showLeaderBonusPanel">
                        Manager Bonus
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ {{bonusService.getBonus(bonusType.MANAGER_BONUS_6)|contractAmountSum}}</span>
                </div>
            </div>
            <div class="panel" *ngIf="showLeaderBonusPanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row">
                        <div class="flex-left">
                            <div>Diretto</div>
                        </div>
                        <div class="flex-right">
                            <div>Bonus</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>EXECUTIVE</div>
                        </div>
                        <div class="flex-right">
                            <div>€ 300,00</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>SENIOR</div>
                        </div>
                        <div class="flex-right">
                            <div>€ 400,00</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>LEADER</div>
                        </div>
                        <div class="flex-right">
                            <div>€ 500,00</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br>
</div>

<div class="flex-panel" *ngIf="period == 'annuale'">
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showAmbassadorBonusPanel = !showAmbassadorBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showAmbassadorBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showAmbassadorBonusPanel">
                        Ambassador Bonus
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ {{bonusService.getBonus(bonusType.AMBASSADOR_BONUS_7)|contractAmountSum}}</span>
                </div>
            </div>
            <div class="panel" *ngIf="showAmbassadorBonusPanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row">
                        <div class="flex-left">
                            <div>Volume</div>
                        </div>
                        <div class="flex-right">
                            <div>Bonus</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>50.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>100.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>2,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>150.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>3,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>200.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>4,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>250.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>5,00%</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showCompanyBonusPanel = !showCompanyBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showCompanyBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showCompanyBonusPanel">
                        Company Bonus
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ 0</span>
                </div>
            </div>
            <div class="panel" *ngIf="showCompanyBonusPanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row">
                        <div class="flex-left">
                            <div>Volume</div>
                        </div>
                        <div class="flex-right">
                            <div>Bonus</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>1.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,50%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>2.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,75%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>3.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,00%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>4.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,25%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>5.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,50%</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showDirectorBonusPanel = !showDirectorBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showDirectorBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showDirectorBonusPanel">
                        Director Bonus
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ 0</span>
                </div>
            </div>
            <div class="panel" *ngIf="showDirectorBonusPanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row">
                        <div class="flex-left">
                            <div>Volume</div>
                        </div>
                        <div class="flex-right">
                            <div>Bonus</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>1.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,20%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>2.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,40%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>3.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,60%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>4.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>0,80%</div>
                        </div>
                    </div>
                    <div class="flex-row volume-level">
                        <div class="flex-left">
                            <div>5.000.000 €</div>
                        </div>
                        <div class="flex-right">
                            <div>1,00%</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>


</div>

<div class="flex-panel" *ngIf="period == 'personale'">
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showMarketingFeePanel = !showMarketingFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showMarketingFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showMarketingFeePanel">
                        Marketing Fee
                    </div>
                </div>
                <div class="flex-right">
              <span
                      class="color-white">€ {{(careerController?.marketingFee1$|async)?.total}}</span>
                </div>
            </div>
            <div class="panel" *ngIf="showMarketingFeePanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row" *ngFor="let b of (careerController?.marketingFee1$|async)?.bonuses">
                        <div class="flex-left">{{b?.info}}</div>
                        <div class="flex-right">€ {{b?.total}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showRevenueFeePanel = !showRevenueFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showRevenueFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showRevenueFeePanel">
                        Revenue Fee
                    </div>
                </div>
                <div class="flex-right">
              
              <span class="color-white"
                    *ngIf="(careerController?.revenueFee4$|async)>1">{{careerController?.revenueFee4$|async}}</span>
                    <div *ngIf="(careerController?.revenueFee4$|async)<1">
                        <b>{{(careerController?.revenueFee4$|async) * 100}} %</b>
                        <ion-progress-bar *ngIf="careerController?.revenueFee4$|async"
                                          [value]="careerController?.revenueFee4$|async"></ion-progress-bar>
                    </div>

                </div>
            </div>
        </div>
        <div class="panel" *ngIf="showRevenueFeePanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="flex-row">
                    <div class="flex-left">
                        <div>Volume</div>
                    </div>
                    <div class="flex-right">
                        <div>Bonus</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>100.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,00%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>200.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,25%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>300.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,50%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>400.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,75%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>500.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>2,00%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showAmbassadorBonusPanel = !showAmbassadorBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showAmbassadorBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showAmbassadorBonusPanel">
                        Ambassafor Bonus
                    </div>
                </div>
                <div class="flex-right">

                    <span class="color-white">€ 500</span>

                </div>
            </div>
        </div>
        <div class="panel" *ngIf="showAmbassadorBonusPanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="flex-row">
                    <div class="flex-left">
                        <div>Volume</div>
                    </div>
                    <div class="flex-right">
                        <div>Bonus</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>50.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,00%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>100.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>2,00%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>150.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>3,00%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>200.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>4,00%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>250.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>5,00%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<div class="flex-panel" *ngIf="period == 'squadra'">
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showTeamBonusPanel = !showTeamBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showTeamBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showTeamBonusPanel">
                        Team Bonus
                    </div>
                </div>
                <div class="flex-right">
              <span class="color-white"
                    *ngIf="(careerController?.teamBonus3$|async)>1">{{careerController?.teamBonus3$|async}}</span>
                    <div *ngIf="(careerController?.teamBonus3$|async)<1">
                        <b>{{(careerController?.teamBonus3$|async) * 100}} %</b>
                        <ion-progress-bar *ngIf="careerController?.teamBonus3$|async"
                                          [value]="careerController?.teamBonus3$|async"></ion-progress-bar>
                    </div>


                </div>
            </div>
        </div>
        <div class="panel" *ngIf="showTeamBonusPanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="flex-row">
                    <div class="flex-left">
                        <div>Volume</div>
                    </div>
                    <div class="flex-right">
                        <div>Bonus</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>N° MEMBRI * 10.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,50%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>N° MEMBRI * 20.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,05%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>N° MEMBRI * 30.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,50%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showCompanyBonusPanel = !showCompanyBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showCompanyBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showCompanyBonusPanel">
                        Company Bonus
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ 100</span>


                </div>
            </div>
        </div>
        <div class="panel" *ngIf="showCompanyBonusPanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="flex-row">
                    <div class="flex-left">
                        <div>Volume</div>
                    </div>
                    <div class="flex-right">
                        <div>Bonus</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>1.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,50%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>2.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,75%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>3.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,00%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>4.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,25%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>5.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,50%</div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showDirectorBonusPanel = !showDirectorBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showDirectorBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showDirectorBonusPanel">
                        Director Bonus
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ 50</span>


                </div>
            </div>
        </div>
        <div class="panel" *ngIf="showDirectorBonusPanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="flex-row">
                    <div class="flex-left">
                        <div>Volume</div>
                    </div>
                    <div class="flex-right">
                        <div>Bonus</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>1.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,20%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>2.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,40%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>3.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,60%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>4.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,80%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>5.000.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,00%</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="flex-panel" *ngIf="period == 'rete'">
    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showManagerFeePanel = !showManagerFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showManagerFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showManagerFeePanel">
                        Manager Fee
                    </div>
                </div>
                <div class="flex-right">
              <span
                      class="color-white">€ {{(careerController?.mmanagerFee2$|async)?.total}}</span>
                </div>
            </div>
            <div class="panel" *ngIf="showManagerFeePanel">
                <div class="glass-blurred-background drop-shadow padding">
                    <div class="flex-row" *ngFor="let b of (careerController?.mmanagerFee2$|async)?.bonuses">
                        <div class="flex-left">{{b?.info}}</div>
                        <div class="flex-right">€ {{b?.total}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showSponsorFeePanel = !showSponsorFeePanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showSponsorFeePanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showSponsorFeePanel">
                        Sponsor Fee
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ {{careerController?.sposnerFee5$|async}}</span>
                </div>
            </div>
        </div>
        <div class="panel" *ngIf="showSponsorFeePanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="flex-row">
                    <div class="flex-left">
                        <div>Volume</div>
                    </div>
                    <div class="flex-right">
                        <div>Bonus</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>100.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,50%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>200.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>0,75%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>300.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,00%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>400.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,25%</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>500.000 €</div>
                    </div>
                    <div class="flex-right">
                        <div>1,50%</div>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <br>

    <div class="glass-blurred-background padding full-width text-bold">
        <div class="flex-collapsible">
            <div class="flex-row header" (click)="showLeaderBonusPanel = !showLeaderBonusPanel">
                <div class="flex-left wide">
                    <div>
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg"
                             *ngIf="showLeaderBonusPanel">
                        <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg"
                             *ngIf="!showLeaderBonusPanel">
                        Leader Bonus
                    </div>
                </div>
                <div class="flex-right">
                    <span class="color-white">€ 300</span>
                </div>
            </div>
        </div>
        <div class="panel" *ngIf="showLeaderBonusPanel">
            <div class="glass-blurred-background drop-shadow padding">
                <div class="flex-row">
                    <div class="flex-left">
                        <div>diretto</div>
                    </div>
                    <div class="flex-right">
                        <div>Bonus</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>EXECUTIVE</div>
                    </div>
                    <div class="flex-right">
                        <div>€ 300,00</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>SENIOR</div>
                    </div>
                    <div class="flex-right">
                        <div>€ 400,00</div>
                    </div>
                </div>
                <div class="flex-row volume-level">
                    <div class="flex-left">
                        <div>LEADER</div>
                    </div>
                    <div class="flex-right">
                        <div>€ 500,00</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!--
<div class="floating-footer center-content">
    <div class="flex-left text-center font-16">Tot bonus {{ period }}</div>
    <div class="flex-right text-center">
        € {{ (careerController?.marketingFee1$|async)?.total + (careerController?.mmanagerFee2$|async)?.total + (careerController?.teamBonus3$|async)   }}</div>
</div>
-->
